import React from 'react';
import Background from '../../components/Background/Background';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';
import Logo from '../../components/Logo/Logo';
import Button from '../../components/Button/Button';
import Header from '../../components/Header/Header';
import { useNavigate } from 'react-router-dom';

const LearnMore = () => {
  const navigate = useNavigate();

  const onBackToStartClick = () => {
    navigate('/welcome');
  };

  const onGoToAwayzClick = () => {
    window.open('https://awayz.com', '_blank');
  };

  return (
    <Background image='welcome'>
      <Header title='Learn More' />
      <motion.div
        className='frontpage-header'
        variants={fadeIn()}
        initial='hidden'
        animate='enter'
        exit='exit'
      >
        <div className='h-2' />
        <Logo name='awayz' className='max-w-[100%]' />
        <p className='font-normal text-center text-[0.8rem]'>
          Awayz makes travel planning easy by comparing live cash and award
          prices side by side and calculating the points or miles needed to get
          you where you want to go.
        </p>
        <img src='/tablet-1.png' className='w-[80%]' alt='tablet 1' />
        <img src='/tablet-2.png' className='w-[80%]' alt='tablet 2' />
      </motion.div>
      <Button onClick={onGoToAwayzClick}>Go To Awayz</Button>
      <Button type='secondary' onClick={onBackToStartClick}>
        Back to Start
      </Button>
    </Background>
  );
};

export default LearnMore;
